import React, {useEffect, useState} from 'react';

import AbstractWindow from './AbstractWindow';

import { useParams, useHistory } from 'react-router-dom';

import { useCarsState } from '../../providers/CarsProvider';

import { patchUser, postUser } from './../../api/cars';

const UserDetailWindow = () => {

    const { carIdOrSlug } = useParams();

    const { userId } = useParams();

    const [ state, setState ] = useState( {} );

    const [ carsState, carsDispatch ] = useCarsState();

    const history = useHistory();

    const [ submitError, setSubmitError ] = useState()

    useEffect( () => {

        let id = Number( userId )

        if( Number.isNaN( id ) ){

            setState({ 
                is_staff: false,
                password: "turbo#Study911"
            })
        } else {
            
            let user = carsState.usersList.find( user => user.id == Number( userId ) )

            if( user ) setState( { ...user } )
        }
    }, [] )

    const checkSaveResponse = ( response ) => {

        if( response.id ) {

            history.goBack()

            let _data = { ...response }

            if( _data.password ) delete _data.password

            carsDispatch({ type:'addSaveUser', data: _data })
        } else {

            setSubmitError( JSON.parse( response ) )
        }
    }

    const onSave = e => {

        e.stopPropagation(); 

        if( !state.first_name ) return setSubmitError( { first_name : 'First name cannot be blank' } );

        if( !state.email ) return setSubmitError( { email : 'Email cannot be blank' } );

        if( !state.id && !state.password ) return setSubmitError( { password : 'Password cannot be blank' } );

        if( state.email ){

            let email_regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

            if( !state.email.match( email_regex ) ) return setSubmitError( { email : 'Please enter a valid email address' } );
        }

        if( state.password ){

            if( state.password.length < 8 ) return setSubmitError( { password : 'Password must be 8 or more characters' } );

            let regex = /(?=.*[A-Z])/g;

            if( !state.password.match( regex ) ) return setSubmitError( { password : 'Password must contain at least one capital letter' } );

            regex = /(?=.*[a-z])/g;

            if( !state.password.match( regex ) ) return setSubmitError( { password : 'Password must contain at least one lowercase letter' } );

            regex = /(?=.*\d)/g;

            if( !state.password.match( regex ) ) return setSubmitError( { password : 'Password must contain at least one number' } );

            regex = /(?=.*?[#?!@$%^&*-])/g

            if( !state.password.match( regex ) ) return setSubmitError( { password : 'Password must contain at least one special character' } );

            setSubmitError( null )
        }

        let data = { 
            first_name : state.first_name, 
            last_name: state.last_name, 
            email: state.email, 
            is_staff: state.is_staff
        }

        if( state.password && state.password !== "" ){

            data.password = state.password
        }

        if( state.id ){

            patchUser( carIdOrSlug, state.id, data ).then( response => checkSaveResponse( response ) );
        } else {

            postUser( carIdOrSlug, data ).then( response => checkSaveResponse( response ) );
        }
    }

    const parseErrorValue = key => {

        return Array.isArray( submitError[ key ] ) ? submitError[ key ].join(', ') : submitError[ key ]
    }

    return <AbstractWindow id={ 'configuration-detail' } className="d-flex align-items-center justify-content-center" style={{backgroundColor:"#eeeeee66"}}>
        <div className="bg-white d-flex p-2 rounded-4 align-items-start" style={{width:500}}>
            <div className="flex-grow-1 d-flex flex-wrap pos-rel" style={{ gap:10 }}>
                <div className="d-flex flex-column" style={{gap:4}}>
                    <h6 className="small bold">First Name</h6>
                    <input className="h5" onChange={e=>setState({...state, first_name: e.target.value })} type="text" value={ state.first_name || "" } />
                    { submitError && submitError.first_name && <p className="text-admin-secondary">{ parseErrorValue( "first_name" ) }</p> }
                </div>
                <div className="d-flex flex-column" style={{gap:4}}>
                    <h6 className="small bold">Last Name</h6>
                    <input className="h5" onChange={e=>setState({...state, last_name: e.target.value })} type="text" value={ state.last_name || "" } />
                    { submitError && submitError.last_name && <p className="text-admin-secondary">{ parseErrorValue( "last_name" ) }</p> }
                </div>
                <div className="d-flex flex-column w-100" style={{gap:4}}>
                    <h6 className="small bold">{`Username (email)`}</h6>
                    <input className="h5" onChange={e=>setState({...state, email: e.target.value })} type="email" value={ state.email || "" } />
                    { submitError && submitError.email && <p className="text-admin-secondary">{ parseErrorValue( "email" ) }</p> }
                    { submitError && submitError.username && <p className="text-admin-secondary">{ parseErrorValue( "username" ) }</p> }
                </div>
                <div className="d-flex flex-column w-100" style={{gap:4, display:'none'}}>
                    <h6 className="small bold">{ state.id ? `Change Password` : `Password`}</h6>
                    <input className="h5" onChange={e=>setState({...state, password: e.target.value })} type="text" value={ state.password || "" } />
                    { submitError && submitError.password && <p className="text-admin-secondary">{ parseErrorValue( "password" ) }</p> }
                </div>
                <div className="d-flex align-items-center" style={{gap:4}}>
                    <h6 className="small bold">Enable Configurations</h6>
                    <input className="" type="checkbox" checked={ !state.is_staff || state.is_staff == false } onChange={ e => setState( { ...state, is_staff: e.target.checked == false } ) }  />
                </div>
                <div className="d-flex align-items-center w-100" style={{gap:10}}>
                    <button onClick={ e =>{ e.stopPropagation(); history.goBack() }} className="ml-auto bg-black text-white rounded-4 p-1">
                        <h6>Cancel</h6>
                    </button>
                    <button onClick={ onSave } className="bg-black text-white rounded-4 p-1">
                        <h6>Save</h6>
                    </button>
                </div>
            </div>
        </div>
    </AbstractWindow>
}

UserDetailWindow.propTypes = {
}

export default UserDetailWindow;